import { render, staticRenderFns } from "./style-settings.vue?vue&type=template&id=56737eae&"
import script from "./style-settings.vue?vue&type=script&lang=js&"
export * from "./style-settings.vue?vue&type=script&lang=js&"
import style0 from "./style-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports